import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperience, IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { compact } from 'lodash';
import { getUserActorForKey } from '../../../../../../services/experiences/instance';
import {
  groupTimelineItemsByActor,
  hasActorTimelineItems
} from '../../../../../../services/experiences/template';
import type { ExperienceProblemData } from '../../InstanceProblems';

export const collectMissingSupportingActors = (
  tpl: Doc<IExperienceTemplate>,
  d: Doc<IExperience>
): ExperienceProblemData[] => {
  const timelineItemsGroupedByActor = groupTimelineItemsByActor(tpl);
  return compact(
    Object.values(tpl.data.supportingActors).map((actor) => {
      if (
        !!getUserActorForKey(d, actor.key)?.userId ||
        actor.ignoreWhenMissing ||
        !!d.data.ignoredMissingActors[actor.key]?.ignored ||
        !hasActorTimelineItems(actor.key, timelineItemsGroupedByActor)
      ) {
        return null;
      }

      const errData: ExperienceProblemData = {
        type: 'MISSING_ACTOR',
        tpl,
        instance: d,
        id: d.data.id,
        actor: actor
      };
      return errData;
    })
  );
};
